import { TransactionsModalStyled } from '../../Account/components/styled/TransactionsModalStyled';
import { LoadableLoader } from '../../../components/loadable/LoadableLoader';

function TransactionModalLoadableFallback() {
    return <TransactionsModalStyled>
        <LoadableLoader/>
    </TransactionsModalStyled>
}

export default TransactionModalLoadableFallback;
